<template>
    <div class="time-input">
        <span class="time-block">
            <label :for="`tp-${random}-hours`" class="time-label">Hrs.</label>
            <input
                :id="`tp-${random}-hours`"
                v-mask="'##'"
                v-model="hours"
                name="hours"
                @blur="padZero('hours')"
                type="text"
                class="time-unit"
                placeholder="00"
                dusk="ti-h"
            />
        </span>
        <span class="colon-divider">:</span>
        <span class="time-block">
            <label :for="`tp-${random}-minutes`" class="time-label">Min.</label>
            <input
                :id="`tp-${random}-minutes`"
                v-mask="'##'"
                v-model="minutes"
                name="minutes"
                @blur="padZero('minutes')"
                type="text"
                class="time-unit"
                placeholder="00"
                dusk="ti-m"
            />
        </span>
        <span class="colon-divider">:</span>
        <span class="time-block">
            <label :for="`tp-${random}-seconds`" class="time-label">Sec.</label>
            <input
                :id="`tp-${random}-seconds`"
                v-mask="'##'"
                v-model="seconds"
                name="seconds"
                @blur="padZero('seconds')"
                type="text"
                class="time-unit"
                placeholder="00"
                dusk="ti-s"
            />
        </span>
    </div>
</template>

<script>
export default {
    name: "TimeInput",
    props: ["value"],
    data() {
        return {
            random: parseInt(Math.random() * 1e6),
            hours: null,
            minutes: null,
            seconds: null,
        };
    },
    mounted() {
        setTimeout(this.initialize, 0);
    },
    watch: {
        value() {
            if (!this.value) {
                //NaN, null, undefined or zero
                this.hours = "00";
                this.minutes = "00";
                this.seconds = "00";
            }
        },
        hours() {
            if (isNaN(parseInt(this.hours))) {
                this.hours = "00";
            }
        },
        minutes() {
            if (isNaN(parseInt(this.minutes))) {
                this.minutes = "00";
                return;
            }
            if (parseInt(this.minutes) > 59) {
                this.minutes = "59";
            }
        },
        seconds() {
            if (isNaN(parseInt(this.seconds))) {
                this.seconds = "00";
                return;
            }
            if (parseInt(this.seconds) > 59) {
                this.seconds = "59";
            }
        },
        timeInSeconds() {
            this.$emit("input", this.timeInSeconds);
        },
    },
    computed: {
        timeInSeconds() {
            return (
                (parseInt(this.hours) || 0) * 3600 +
                (parseInt(this.minutes) || 0) * 60 +
                (parseInt(this.seconds) || 0)
            );
        },
    },
    methods: {
        initialize() {
            let time = this.value;
            this.hours = Math.floor(time / 3600);
            time = time - this.hours * 3600;
            this.minutes = ("0" + Math.floor(time / 60)).slice(-2);
            time = time - this.minutes * 60;
            this.seconds = ("0" + time).slice(-2);
        },

        padZero(prop) {
            if (parseInt(this[prop]) < 10) {
                this[prop] = ("0" + this[prop]).slice(-2);
            }
        },
    },
};
</script>

<style scoped lang="scss">
.time-input {
    padding: 0.125rem;
    display: inline-block;
    border-radius: 0.25rem;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
}
.time-block {
    position: relative;
}
.time-label {
    position: absolute;
    top: -5px;
    left: 5px;
    font-style: italic;
    font-size: 8px;
    color: gray;
    line-height: 8px;
}
.time-unit {
    background: white;
    border: none;
    padding: 5px 5px 0;
    text-align: right;
    width: 3.5ch;
}
.colon-divider {
    text-align: center;
}

@media screen and (max-width: 1199px) {
    .time-label {
        top: 0;
        font-size: 7px;
    }
    .time-unit {
        padding: 0;
        font-size: 0.65rem;
    }
}
</style>
